import { render, staticRenderFns } from "./CustomFieldsFromType.vue?vue&type=template&id=03961e70&scoped=true&"
import script from "./CustomFieldsFromType.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsFromType.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsFromType.vue?vue&type=style&index=0&id=03961e70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03961e70",
  null
  
)

export default component.exports